import styled from 'styled-components';
import { gridSizes, media, weights, zIndexses } from 'utils/style';

import Feedback from 'components/Feedback/container';

export default styled(Feedback)`
  box-shadow: 0 2px ${gridSizes('S')} 0 rgba(0, 0, 0, 0.2);
  background-color: #e9ffd6;
  div {
    background-color: #e9ffd6;
  }

  align-items: center;
  margin-right: auto;
  width: 400px;
  margin-left: -5vw;
  text-align: center;
  border-radius: 4px;

  position: fixed;
  z-index: ${zIndexses.feedBack};
  left: 50%;
  bottom: -100px;
  font-size: ${gridSizes('M')};
  font-weight: ${weights('medium')};

  ${media.greaterThan('medium')`
        animation: fadein 0.3s,stay 3s 0.3s, fadeout 0.5s 3.3s;
    `};

  ${media.lessThan('medium')`
        min-width: 92%;
        left: 4%;
        bottom: 100px;
        font-size: 14px;
        margin: auto;
        bottom: -50px;
        animation: fadeinMedium 0.3s,stayMedium 3s 0.3s, fadeoutMedium 0.5s 3.3s;

  `};

  transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 0.1);

  @-webkit-keyframes fadein {
    from {
      bottom: -100px;
      opacity: 0;
    }
    to {
      bottom: ${gridSizes('L')};
      opacity: 1;
    }
  }

  @keyframes fadein {
    from {
      bottom: -100px;
      opacity: 0;
    }
    to {
      bottom: ${gridSizes('L')};
      opacity: 1;
    }
  }

  @keyframes stay {
    from {
      bottom: ${gridSizes('L')};
      opacity: 1;
    }
    to {
      bottom: ${gridSizes('L')};
      opacity: 1;
    }
  }

  @-webkit-keyframes stay {
    from {
      bottom: ${gridSizes('L')};
      opacity: 1;
    }
    to {
      bottom: ${gridSizes('L')};
      opacity: 1;
    }
  }

  @-webkit-keyframes fadeout {
    from {
      bottom: ${gridSizes('L')};
      opacity: 1;
    }
    to {
      bottom: -100px;
      opacity: 0;
    }
  }

  @keyframes fadeout {
    from {
      bottom: ${gridSizes('L')};
      opacity: 1;
    }
    to {
      bottom: -100px;
      opacity: 0;
    }
  }

  @-webkit-keyframesmedium fadein {
    from {
      bottom: -50px;
      opacity: 0;
    }
    to {
      bottom: 100px;
      opacity: 1;
    }
  }

  @keyframes fadeinMedium {
    from {
      bottom: -50px;
      opacity: 0;
    }
    to {
      bottom: 100px;
      opacity: 1;
    }
  }

  @keyframes stayMedium {
    from {
      min-width: 92%;
      bottom: 100px;
      opacity: 1;
    }
    to {
      min-width: 92%;
      bottom: 100px;
      opacity: 1;
    }
  }

  @-webkit-keyframes stayMedium {
    from {
      min-width: 92%;
      bottom: 100px;
      opacity: 1;
    }
    to {
      min-width: 92%;
      bottom: 100px;
      opacity: 1;
    }
  }

  @-webkit-keyframes fadeoutMedium {
    from {
      bottom: 100px;
      opacity: 1;
    }
    to {
      bottom: -50px;
      opacity: 0;
    }
  }

  @keyframes fadeoutMedium {
    from {
      bottom: 100px;
      opacity: 1;
    }
    to {
      bottom: -50px;
      opacity: 0;
    }
  }
`;
